import PropTypes from 'prop-types';
import {Box, Stack, Typography, useMediaQuery} from '@mui/material';
import {Logo} from 'src/components/logo';

import {projectName, appVersion} from "../../config";

export const Layout = (props) => {
    const {children} = props;
    const smUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                backgroundColor: 'background.default',
                display: 'flex',
                flex: '1 1 auto',
                flexDirection: {
                    xs: 'column',
                    md: 'row'
                }
            }}
        >
            {smUp &&
                <Box
                    sx={{
                        alignItems: 'center',
                        backgroundColor: 'neutral.800',
                        backgroundImage: 'url("/assets/gradient-bg.svg")',
                        backgroundPosition: 'top center',
                        backgroundRepeat: 'no-repeat',
                        color: 'common.white',
                        display: 'flex',
                        flex: {
                            xs: '0 0 auto',
                            sm: '10 1 auto',
                            md: '1 1 auto'
                        },
                        justifyContent: 'center',
                        p: {
                            xs: 4,
                            md: 8
                        }
                    }}
                >
                    <Box maxWidth="md">
                        <Box sx={{height: '100px', margin: 2}}>
                            <Logo height={180}/>
                        </Box>
                    </Box>
                </Box>
            }
            <Box
                sx={{
                    backgroundColor: 'background.paper',
                    display: 'flex',
                    flex: {
                        xs: '1 1 auto',
                        md: '0 0 auto'
                    },
                    flexDirection: 'column',
                    justifyContent: {
                        md: 'center'
                    },
                    maxWidth: '100%',
                    p: {
                        xs: 4,
                        md: 8
                    },
                    width: {
                        md: 600
                    }
                }}
            >
                {smDown &&
                    <Box
                        sx={{
                            alignItems: 'center',
                            color: 'common.white',
                            display: 'flex',
                            flex: {
                                xs: '0 0 auto',
                                sm: '10 1 auto',
                                md: '1 1 auto'
                            },
                            justifyContent: 'center',
                            p: {
                                xs: 2,
                                md: 4
                            }
                        }}
                    >
                        <Box maxWidth="xs">
                            <Box sx={{height: '100px', margin: 3}}>
                                <Logo height={120}/>
                            </Box>
                        </Box>
                    </Box>}
                <div>
                    <Box sx={{mb: 4}}>
                        <Stack
                            alignItems="center"
                            direction="column"
                            display="inline-flex"
                            spacing={1}
                            sx={{textDecoration: 'none'}}
                        >
                            <Box
                                sx={{
                                    color: 'text.primary',
                                    fontSize: 14,
                                    fontWeight: 800,
                                    letterSpacing: '0.3px',
                                    lineHeight: 2.5,
                                    '& span': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                Welcome to {projectName}

                            </Box>
                        </Stack>
                    </Box>
                    {children}
                    <Typography fontSize={12} >
                        ver.{appVersion}
                    </Typography>
                </div>
            </Box>
        </Box>
    );
};

Layout.propTypes = {
    children: PropTypes.node
};
